import { motion } from "framer-motion";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";

const CHANNELS = [
  { id: "instagram", name: "Instagram", handle: "@theopentale", url: "https://www.instagram.com/theopentale/", Icon: Instagram },
  { id: "facebook", name: "Facebook", handle: "@theopentale", url: "https://www.facebook.com/theopentale/", Icon: Facebook },
];

export const Social = () => (
  <section id="follow" data-testid="follow-section" className="relative py-24 sm:py-32">
    <div className="pointer-events-none absolute left-1/2 top-0 h-80 w-80 -translate-x-1/2 rounded-full bg-cyan-500/10 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto max-w-3xl text-center"
      >
        <p className="font-mono text-[11px] tracking-[0.35em] text-cyan-400">WE&rsquo;RE LIVE ON SOCIAL</p>
        <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-5xl">
          Follow the{" "}
          <span className="brand-gradient-text font-editorial font-normal italic">first chapter.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
          While the full website is being built, The Open Tale is already publishing on social media. Join us
          there for daily dispatches and preview stories — the full publication launches here soon.
        </p>
      </motion.div>

      <div className="mx-auto mt-14 grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2">
        {CHANNELS.map((c, i) => (
          <motion.a
            key={c.id}
            data-testid={`follow-${c.id}-card`}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="group flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.03] p-6 backdrop-blur transition-all duration-500 hover:-translate-y-1 hover:border-cyan-400/40 hover:bg-cyan-400/[0.06] hover:shadow-[0_12px_40px_rgba(6,182,212,0.15)] sm:p-7"
          >
            <div className="flex items-center gap-4">
              <span className="rounded-full border border-cyan-400/30 bg-cyan-400/10 p-3 text-cyan-300 transition-transform duration-500 group-hover:scale-110">
                <c.Icon className="h-5 w-5" />
              </span>
              <div>
                <p className="font-display text-base font-extrabold tracking-tight">{c.name}</p>
                <p className="mt-0.5 font-mono text-[11px] tracking-[0.2em] text-slate-500">{c.handle}</p>
              </div>
            </div>
            <ArrowUpRight className="h-5 w-5 text-slate-500 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-cyan-300" />
          </motion.a>
        ))}
      </div>

      <motion.p
        data-testid="follow-coming-soon-note"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay: 0.3 }}
        className="mt-12 text-center font-mono text-[11px] tracking-[0.3em] text-slate-500"
      >
        FULL WEBSITE — <span className="text-cyan-300">COMING SOON</span>
      </motion.p>
    </div>
  </section>
);
